module.exports = __webpack_public_path__ + "static/img/product05.87d76db.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/product05.png
// module id = ox+o
// module chunks = 1